import caviarImg from '@/assets/caviar.webp'
import sturgeonImg from '@/assets/sturgeon.webp'
import freshFishImg from '@/assets/fresh-fish.webp'
import canFishImg from '@/assets/can-fish.webp'
import { absoluteUrl, COMPANY } from '@/lib/site'

export const PRODUCT_GROUPS = [
  {
    id: 'caviar',
    slug: 'chernaya-ikra',
    href: '/products/chernaya-ikra',
    title: 'Чёрная икра',
    shortTitle: 'Чёрная икра',
    desc: 'Икра осетровых рыб высшего качества',
    image: caviarImg,
    imageAlt: 'Чёрная икра осетровых пород СК-АКВА',
    intro:
      'Производим чёрную икру осетровых пород на собственных площадках полного цикла. Подбираем фасовку и объём под розничный заказ, ресторан, магазин или оптовую поставку.',
    audience: ['розничные покупатели', 'рестораны и HoReCa', 'оптовые клиенты', 'партнёры по поставкам'],
    benefits: [
      'Собственное выращивание осетровых пород с 2010 года',
      'Фасовки 100 г, 250 г и 1 кг для разных сценариев закупки',
      'Поставка по России с соблюдением температурного режима',
      'Документы на продукцию предоставляются при оформлении поставки',
    ],
    faq: [
      {
        q: 'Можно ли заказать чёрную икру оптом?',
        a: 'Да, объём, фасовка, сроки и условия поставки обсуждаются индивидуально с менеджером.',
      },
      {
        q: 'Какая фасовка доступна?',
        a: 'В каталоге указаны фасовки 100 г, 250 г и 1 кг. Для регулярных поставок можно согласовать спецификацию отдельно.',
      },
    ],
    items: [
      {
        slug: 'ikra-osetra',
        href: '/products/ikra-osetra',
        name: 'Икра осетра',
        title: 'Икра осетра',
        desc: 'Классическая осетровая икра для розничных заказов, ресторанов и оптовых поставок.',
        rows: [
          { label: '100 г', retail: '4 500 ₽', price: 4500 },
          { label: '250 г', retail: '11 250 ₽', price: 11250 },
          { label: '1 кг', retail: '45 000 ₽', price: 45000 },
        ],
      },
      {
        slug: 'ikra-sterlyadi',
        href: '/products/ikra-sterlyadi',
        name: 'Икра стерляди',
        title: 'Икра стерляди',
        desc: 'Икра стерляди с аккуратной фасовкой для частных покупателей и профессиональной кухни.',
        rows: [
          { label: '100 г', retail: '3 500 ₽', price: 3500 },
          { label: '250 г', retail: '8 750 ₽', price: 8750 },
          { label: '1 кг', retail: '35 000 ₽', price: 35000 },
        ],
      },
      {
        slug: 'ikra-bestera',
        href: '/products/ikra-bestera',
        name: 'Икра бестера',
        title: 'Икра бестера',
        desc: 'Икра бестера для поставок в розницу, HoReCa и оптовые каналы.',
        rows: [
          { label: '100 г', retail: '4 500 ₽', price: 4500 },
          { label: '250 г', retail: '11 250 ₽', price: 11250 },
          { label: '1 кг', retail: '45 000 ₽', price: 45000 },
        ],
      },
    ],
  },
  {
    id: 'live',
    slug: 'zhivaya-ryba',
    href: '/products/zhivaya-ryba',
    title: 'Живая осетровая рыба',
    shortTitle: 'Живая рыба',
    desc: 'Осетровые породы, навеска 3–4 кг',
    image: sturgeonImg,
    imageAlt: 'Живая осетровая рыба для поставок',
    intro:
      'Поставляем живую рыбу осетровых пород для ресторанов, переработки, магазинов и партнёров. Навеска и график отгрузки согласуются под задачу клиента.',
    audience: ['рестораны', 'HoReCa', 'переработчики', 'оптовые покупатели'],
    benefits: [
      'Русский осётр и бестер с производственных площадок компании',
      'Навеска от 3–4 кг',
      'Возможность регулярных поставок под заказ',
      'Доставка за 24–48 часов по согласованным направлениям',
    ],
    faq: [
      {
        q: 'Какая навеска доступна для живой рыбы?',
        a: 'Базовая навеска — от 3–4 кг. Точный объём и размер партии согласуются перед поставкой.',
      },
      {
        q: 'Можно ли заказать рыбу для ресторана?',
        a: 'Да, поставка живой рыбы подходит для ресторанов и HoReCa. Условия обсуждаются индивидуально.',
      },
    ],
    items: [
      {
        slug: 'zhivaya-ryba',
        href: '/products/zhivaya-ryba',
        name: 'Русский осётр, бестер',
        title: 'Живая осетровая рыба',
        note: 'Живая рыба, навеска от 3–4 кг',
        desc: 'Живая рыба осетровых пород для профессиональных покупателей и частных заказов.',
        rows: [{ label: '1 кг', retail: '1 250 ₽', price: 1250 }],
      },
    ],
  },
  {
    id: 'meat',
    slug: 'myaso-osetra',
    href: '/products/myaso-osetra',
    title: 'Мясо осетра и стерляди',
    shortTitle: 'Мясо осетровых',
    desc: 'Охлаждённое и замороженное',
    image: freshFishImg,
    imageAlt: 'Охлаждённое мясо осетра и стерляди',
    intro:
      'Предлагаем мясо осетра и стерляди в охлаждённом и замороженном виде. Формат поставки подбирается под ресторан, магазин, переработку или оптового клиента.',
    audience: ['рестораны', 'магазины', 'переработка', 'оптовые клиенты'],
    benefits: [
      'Охлаждённая и замороженная продукция',
      'Поставка тушки осетра и стерляди по запросу',
      'Подготовка партии под спецификацию клиента',
      'Сопроводительные документы при поставке',
    ],
    faq: [
      {
        q: 'Почему цена мяса указана по запросу?',
        a: 'Цена зависит от объёма, формата подготовки, охлаждения или заморозки и логистики.',
      },
      {
        q: 'Можно ли заказать подготовленную рыбу?',
        a: 'Да, возможна поставка потрошёной и подготовленной рыбы по индивидуальному запросу.',
      },
    ],
    items: [
      {
        slug: 'myaso-osetra',
        href: '/products/myaso-osetra',
        name: 'Тушка осетра / стерляди',
        title: 'Мясо осетра и стерляди',
        note: 'Охлаждённая и замороженная',
        desc: 'Тушка осетра или стерляди для ресторанов, магазинов и переработки.',
        rows: [{ label: 'Цена', retail: 'по запросу', price: null }],
      },
    ],
  },
  {
    id: 'proc',
    slug: 'konservy',
    href: '/products/konservy',
    title: 'Переработанная продукция и консервы',
    shortTitle: 'Переработанная продукция',
    desc: 'Потрошёная рыба, филе и полуфабрикаты',
    image: canFishImg,
    imageAlt: 'Консервы из осетра СК-АКВА',
    intro:
      'Готовим переработанную продукцию из осетровых пород: консервы, потрошёную рыбу, филе и полуфабрикаты. Для опта доступна коробочная поставка.',
    audience: ['розничные покупатели', 'магазины', 'оптовые клиенты', 'партнёры'],
    benefits: [
      'Натуральный осётр и осётр в томатном соусе',
      'Оптовая цена при заказе полной коробки',
      'Возможность поставки полуфабрикатов по запросу',
      'Полный пакет документов для коммерческих поставок',
    ],
    faq: [
      {
        q: 'Есть ли оптовая цена на консервы?',
        a: 'Да, при заказе полной коробки действует оптовая цена. Текущая коробка — 48 шт.',
      },
      {
        q: 'Можно ли заказать переработку под задачу?',
        a: 'Да, формат переработанной продукции обсуждается индивидуально.',
      },
    ],
    items: [
      {
        slug: 'osetr-naturalny',
        name: 'Осётр натуральный',
        title: 'Осётр натуральный',
        note: 'Консервы в металлической банке',
        desc: 'Консервы из натурального осетра в металлической банке.',
        rows: [{ label: '1 шт.', retail: '650 ₽', price: 650, wholesale: '500 ₽', wholesalePrice: 500, wholesaleUnit: 48 }],
      },
      {
        slug: 'osetr-v-tomatnom-souse',
        name: 'Осётр в томатном соусе',
        title: 'Осётр в томатном соусе',
        note: 'Обжаренный, консервы в металлической банке',
        desc: 'Обжаренный осётр в томатном соусе, консервы в металлической банке.',
        rows: [{ label: '1 шт.', retail: '650 ₽', price: 650, wholesale: '500 ₽', wholesalePrice: 500, wholesaleUnit: 48 }],
      },
    ],
  },
]

export const PRODUCT_DETAIL_PAGES = PRODUCT_GROUPS.flatMap((group) =>
  group.items
    .filter((item) => item.href && item.href !== group.href)
    .map((item) => ({
      ...item,
      group,
      image: group.image,
      imageAlt: group.imageAlt,
      audience: group.audience,
      benefits: group.benefits,
      faq: group.faq,
    })),
)

export function getProductGroup(slug) {
  return PRODUCT_GROUPS.find((group) => group.slug === slug)
}

export function getProductDetail(slug) {
  return PRODUCT_DETAIL_PAGES.find((product) => product.slug === slug)
}

export function productModalData(group) {
  return {
    title: group.shortTitle,
    desc: group.desc,
    items: group.items,
  }
}

function documentSubjectsJsonLd(documents = []) {
  return documents.map((document) => ({
    '@type': 'DigitalDocument',
    '@id': `${absoluteUrl(document.href)}#document`,
    name: document.title,
    url: absoluteUrl(document.href),
    encodingFormat: document.encodingFormat,
  }))
}

export function productJsonLd(product, documents = []) {
  const rows = product.rows ?? []
  const pricedRows = rows.filter((row) => row.price)
  if (pricedRows.length === 0) return null

  const url = absoluteUrl(product.href ?? product.group?.href ?? '/products')
  const offers = pricedRows.map((row) => ({
    '@type': 'Offer',
    url,
    priceCurrency: 'RUB',
    price: row.price,
    availability: 'https://schema.org/InStock',
    seller: { '@id': absoluteUrl('/#organization') },
    name: `${product.title} — ${row.label}`,
  }))

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    '@id': `${url}#product`,
    url,
    name: product.title,
    description: product.desc,
    image: absoluteUrl('/og-image.webp'),
    brand: { '@type': 'Brand', name: COMPANY.shortName },
  }

  if (offers.length > 0) schema.offers = offers.length === 1 ? offers[0] : offers
  if (documents.length > 0) schema.subjectOf = documentSubjectsJsonLd(documents)
  return schema
}

export function productGroupJsonLd(group, documents = []) {
  if (group.id === 'live') {
    const primaryProduct = group.items[0]
    return [
      productJsonLd({
        ...primaryProduct,
        href: group.href,
        group,
        image: group.image,
        imageAlt: group.imageAlt,
      }, documents),
    ]
  }

  const pageUrl = absoluteUrl(group.href)
  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    '@id': `${pageUrl}#itemlist`,
    itemListElement: group.items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      url: absoluteUrl(item.href ?? `${group.href}#${item.slug ?? index + 1}`),
    })),
  }

  const collectionPage = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${pageUrl}#collection`,
    url: pageUrl,
    name: group.title,
    description: group.intro || group.desc,
    mainEntity: { '@id': itemList['@id'] },
  }

  if (documents.length > 0) collectionPage.subjectOf = documentSubjectsJsonLd(documents)

  return [collectionPage, itemList]
}

export function productItemListJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      url: absoluteUrl(item.href),
    })),
  }
}
